import { render, staticRenderFns } from "./Transportation.vue?vue&type=template&id=2514b53d&scoped=true&"
import script from "./Transportation.vue?vue&type=script&lang=js&"
export * from "./Transportation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514b53d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2514b53d')) {
      api.createRecord('2514b53d', component.options)
    } else {
      api.reload('2514b53d', component.options)
    }
    module.hot.accept("./Transportation.vue?vue&type=template&id=2514b53d&scoped=true&", function () {
      api.rerender('2514b53d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/Transportation.vue"
export default component.exports